import { createSlice } from '@reduxjs/toolkit'

const initialState ={
     supTabValidation : {},
     formValidation : {},

}


const appvalidationSlice = createSlice({
    name: 'appvalidations',
    initialState,
    reducers :{
         wizardvalidation : (state,action) =>{
            state.formValidation =  action.payload
         },
         subTabwizardvalidation : (state,action) =>{
            state.supTabValidation =  action.payload
         }
    }

})
export const {wizardvalidation,subTabwizardvalidation} = appvalidationSlice.actions
export default appvalidationSlice.reducer
